<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.question}` : 'Nova FAQ' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Perguntas e Respostas',
                href: '#/faqs',
              },
              {
                text: 'Cadastro de Perguntas e Respostas',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Pergunta">
                <b-form-input
                  v-model="state.question"
                  required
                  placeholder="Informe o pergunta"
                  :state="isOk('question')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('question')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Resposta"
                label-for="input-2"
              >
                <b-form-textarea
                  v-model="state.answer"
                  placeholder="Informe a resposta"
                  rows="3"
                  max-rows="6"
                  :state="isOk('answer')"
                ></b-form-textarea>
                <b-form-invalid-feedback>{{
                  getError('answer')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Perfil"
                label-for="input-group-3"
              >
                <select v-model="state.profile" class="form-control">
                  <option disabled value>Selecione o perfil</option>
                  <option value="consumer">Consumidor</option>
                  <option value="trader">Comercializador</option>
                  <option value="investor">Investidor</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('profile') }"></div>
                <b-form-invalid-feedback v-if="isOk('profile') === false">{{
                  getError('profile')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Categoria"
                label-for="input-group-3"
              >
                <select v-model="state.category" class="form-control">
                  <option disabled value>Selecione o perfil</option>
                  <option value="ECONOMIZE">Economize</option>
                  <option value="COMERCIALIZE">Comercialize</option>
                  <option value="INVISTA">Invista</option>
                  <option value="ENERGIA">Energia</option>
                  <option value="OUTRAS">Outras</option>
                  <option value="VEINS">Veins</option>
                  <option value="LEGISLACAO">Legislação</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('category') }"></div>
                <b-form-invalid-feedback v-if="isOk('category') === false">{{
                  getError('category')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <image-upload
                :currentUrl="this.state.url"
                :updateUrl="updateUrl"
                :setLoading="setLoadingPhoto"
              ></image-upload>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'faq-edit',
  data: function() {
    return {
      state: {
        question: '',
        answer: '',
        url: '',
        profile: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/faq/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        const result = await API.post('/execute', {
          path: this.viewData.id ? `/faq/${this.viewData.id}` : '/faq/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });

        this.$toast.success('FAQ incluída com sucesso');

        this.$router.push('/faqs');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
